import { render } from "./GraphicProducts.vue?vue&type=template&id=bc59fbce"
import script from "./GraphicProducts.vue?vue&type=script&lang=js"
export * from "./GraphicProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__